__turbopack_context__.v({
  "agenciesBackground": "PageView-module__W4ljeG__agenciesBackground",
  "agenciesWrapper": "PageView-module__W4ljeG__agenciesWrapper",
  "bottomWrapper": "PageView-module__W4ljeG__bottomWrapper",
  "breadcrumbSection": "PageView-module__W4ljeG__breadcrumbSection",
  "coverSection": "PageView-module__W4ljeG__coverSection",
  "mainWrapper": "PageView-module__W4ljeG__mainWrapper",
  "regionsWrapper": "PageView-module__W4ljeG__regionsWrapper",
  "section": "PageView-module__W4ljeG__section",
  "whenToGoSection": "PageView-module__W4ljeG__whenToGoSection",
  "whenToGoWrapper": "PageView-module__W4ljeG__whenToGoWrapper",
  "whereToGoSection": "PageView-module__W4ljeG__whereToGoSection",
});
